import * as React from 'react';
import { DatosDireccion } from '../tipos';
import Campo from './Campo';

interface DireccionProps extends DatosDireccion {
    titulo: string;
}
const Direccion: React.FunctionComponent<DireccionProps> = props => {
    const { titulo, calle, numero, comuna, region, poblacion } = props;
    const dpto = props.dpto ? ', dpto ' + props.dpto : '';
    const block = props.bloque ? ', block ' + props.bloque : '';
    const direccion = calle + ' #' + numero + dpto + block;
    const comunaRegion = comuna + ', ' + region;
    return (
        <span>
            <Campo etiqueta={titulo} valor={direccion} />
            {!!poblacion && <Campo valor={poblacion} />}
            <Campo valor={comunaRegion} />
        </span>
    );
};

export default Direccion;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/Direccion.tsx